import {LOAD_LOGS, LOAD_LOGS_FAIL, LOAD_LOGS_SUCCESS, LoadLogsSuccess} from '../actions/hosting-logs.action';
import {LogAction} from "../actions";
import {HostingLogData} from "../../websites/website/hosting/logs/hostingLogData";

export interface IHostingEntityState {
  entities: {[websiteId: number]: HostingLogData};
  loading: boolean;
  loaded: boolean;
}

export interface IHostingLogsState {
  entities: {[websiteId: number]: IHostingEntityState};
}

export const initialState: IHostingLogsState = {
  entities: {}
};

export function reducer(state: IHostingLogsState = initialState, action: LogAction): IHostingLogsState {
  let payload: any;

  switch (action.type) {

    case LOAD_LOGS:
      payload = (<LoadLogsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_LOGS_SUCCESS:
      payload = (<LoadLogsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_LOGS_FAIL:
      payload = (<LoadLogsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
